import styled from "styled-components";

export const IssuePopover = styled.div`
  max-width: 360px;
  min-width: 220px;
  font-family: Inter, sans-serif;
  color: var(--Dark-Grey, #262641);
`;

export const IssueGroup = styled.div`
  & + & {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #eef0f3;
  }
`;

export const IssueGroupTitle = styled.div`
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  color: ${({ $type }) => {
    if ($type === "warning") return "#aa5b00";
    if ($type === "processed") return "#14804a";
    return "#cf324a";
  }};
`;

export const IssueList = styled.ul`
  margin: 0;
  padding: 0 0 0 18px;
  list-style: disc;
`;

export const IssueItem = styled.li`
  font-size: 13px;
  line-height: 18px;
  color: #4a4a68;

  & + & {
    margin-top: 8px;
  }
`;

export const IssueItemTitle = styled.span`
  font-weight: 600;
  color: #262641;
`;

export const IssueItemMessage = styled.span`
  font-weight: 400;
`;
